module.exports = __webpack_public_path__ + "static/media/figger.c4ccda8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mp3/figger.mp3
// module id = ONjk
// module chunks = 1 3